import React from "react";
import { useTranslation } from "react-i18next";
import { FaCheck, FaRegCopy } from "react-icons/fa";
import { IoLogoWhatsapp, IoMailOutline } from "react-icons/io5";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import { SharePopoverProps } from "@models/shared/shared.model";

const SharePopover: React.FC<SharePopoverProps> = ({
  copied,
  handleCopy,
  handleEmail,
  handleWhatsApp,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      toggle={onClose}
      centered
      className="fg-share-popover-modal"
    >
      <ModalHeader toggle={onClose}>{t("shareBooking")}</ModalHeader>

      <ModalBody>
        <button className="fg-share-action" onClick={handleCopy}>
          {copied ? <FaCheck className="fg-text-success" /> : <FaRegCopy />}
          <span className={copied ? "fg-text-success" : undefined}>
            {copied ? t("copied") : t("copyLink")}
          </span>
        </button>

        <button className="fg-share-action" onClick={handleEmail}>
          <IoMailOutline />
          <span>{t("emailBooking")}</span>
        </button>

        <button className="fg-share-action" onClick={handleWhatsApp}>
          <IoLogoWhatsapp />
          <span>{t("shareWhatsApp")}</span>
        </button>
      </ModalBody>
    </Modal>
  );
};

export default SharePopover;
